import { Text, HStack, Button } from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from '@montel/montelpro-shared-components/enums';
import { ADMIN_ACCOUNT_API_ROUTE } from 'apiRoutes';
import { StandardModal } from 'components/common/Modal/StandardModal';
import useSubmit, { POST } from 'hooks/useSubmit';
import { AdminAccount } from 'domain/account/interfaces/AdminAccount';
import { FunctionComponent } from 'react';

interface ResetPasswordModalProps {
	showModal: boolean;
	setShowModal: (showModal: boolean) => void;
	user: AdminAccount;
	onSuccess: () => void;
}

export const ResetPasswordModal: FunctionComponent<ResetPasswordModalProps> = ({
	showModal,
	setShowModal,
	user,
	onSuccess,
}) => {
	const [resetPassword, resetPasswordStatus] = useSubmit(
		`${ADMIN_ACCOUNT_API_ROUTE}/ResetPassword`,
		POST,
		{
			messageOnSuccess: 'Password reset successfully',
			messageOnError: 'Error resetting password',
			showApiError: true,
		},
	);

	const onPasswordReset = async () => {
		const response = await resetPassword({ adminId: user?.id });
		if (response.success) {
			setShowModal(false);
			onSuccess();
		}
	};

	return (
		<StandardModal
			isOpen={showModal}
			onClose={() => setShowModal(false)}
			header={'Reset Password'}
			footer={
				<HStack gap="md">
					<Button
						text="Reset password"
						size="sm"
						type="submit"
						isLoading={
							resetPasswordStatus === RequestStatus.LOADING
						}
						loadingText="Resetting..."
						onClick={onPasswordReset}
					/>
					<Button
						text="Cancel"
						size="sm"
						variant="secondary"
						onClick={() => setShowModal(false)}
					/>
				</HStack>
			}
		>
			<Text>
				{`Are you sure you want to reset the password	for ${user?.firstName} ${user?.lastName}?`}
			</Text>
		</StandardModal>
	);
};
